import ComparisonChart from "./ComparisonChart";

export default ComparisonChart;
